import React, {useContext} from 'react'
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes'
import {AuditModalApiContext} from '../../../../context/AuditModalApi'

function CustomMultiSelectFieldForAssign(props) {
  const {getSearchUsers, getSearchTemplates, getSearchUserEmails} = useContext(AuditModalApiContext)
  const [searchLoading, setSearchLoading] = React.useState(false)
  const [searchWarning, setSearchWarning] = React.useState(false)
  const [searchText, setSearchText] = React.useState('')

  const renderSelectedLabel = (placeholderButtonLabel, value) => {
    // props.scrollToBottom()
    if (!value) return placeholderButtonLabel
    if (!Array.isArray(value)) return value.label

    value = value.filter(item => item.value !== 'select_all')

    if (value.length === 0) return placeholderButtonLabel
    if (value.length > 3) {
      return (
        <div className="css-1v99tuv">
          {value.slice(0, 3).map(val => {
            return <span className="selected-data">{val.label}</span>
          })}
          <span className="selected-data-3">+{value.length - 3}</span>
        </div>
      )
    }
    return (
      <div className="css-1v99tuv">
        {value.map(val => {
          return <span className="selected-data">{val.label}</span>
        })}
      </div>
    )
  }

  const checkSelectAll = currOption => {
    const {action, option} = currOption
    const isSelectAll = option.value === 'select_all' && action === 'select-option'
    const isDeselectAll = option.value === 'select_all' && action === 'deselect-option'
    const isNoting = option.value !== 'select_all' && action === 'deselect-option'
    return {isSelectAll, isDeselectAll, isNoting}
  }

  const handleStateChange = (e, currOption) => {
    if (currOption.action === 'clear') {
      setSearchText('')
    } else if (checkSelectAll(currOption).isSelectAll) {
      e = props.optionItems.filter(item => item.value !== 'select_all')
      props.handleChange(e)
    } else if (checkSelectAll(currOption).isDeselectAll) {
      props.handleChange([])
    } else {
      e = e.filter(item => item.value !== 'select_all')
      props.handleChange(e)
    }
  }

  const handleSearchInput = (searchText, {action}) => {
    setSearchWarning(false)
    if (action === 'menu-close' || action === 'input-blur' || action === 'set-value') {
      return
    } else {
      if (action === 'input-change') {
        setSearchText(searchText)
      }
    }
  }

  const getSearchOptions = e => {
    if (props.menuIsOpen && 'Enter' === e.key) {
      e.preventDefault()
      if (searchText !== '' && searchText.length >= 3) {
        setSearchLoading(true)
        if (props.assignFor === 'user') {
          getSearchUsers(searchText).then(() => {
            setSearchLoading(false)
          })
        } else if (props.assignFor === 'template') {
          getSearchTemplates(searchText).then(() => {
            setSearchLoading(false)
          })
        } else if (props.assignFor === 'userTemplate') {
          getSearchUserEmails(searchText).then(() => {
            setSearchLoading(false)
          })
        }
      }
    }
  }

  let selectesItems = props.value.map(item => {
    let label,
      value = ''
    if (item.template_id !== undefined) {
      label = item.template_name
      value = item.template_id
    } else if (item.user_id !== undefined) {
      label = item.user_name
      value = item.user_id
    } else if (item.field_id !== undefined) {
      label = item.field_name
      value = item.field_id
    }
    return {
      label: label,
      value: value,
    }
  })
  if (props.value.length === props.optionItems.length - 1) {
    selectesItems.unshift({label: 'Select All', value: 'select_all'})
  }

  return (
    <>
      <ReactMultiSelectCheckboxes
        menuIsOpen={props.menuIsOpen}
        value={selectesItems}
        placeholder="Search"
        tabSelectsValue={false}
        onInputChange={(e, action) => handleSearchInput(e, action)}
        inputValue={searchText}
        onKeyDown={e => getSearchOptions(e)}
        isLoading={searchLoading}
        isClearable={searchText ? true : false}
        onMenuScrollToTop={() => setSearchWarning(false)}
        onMenuScrollToBottom={() => setSearchWarning(true)}
        options={props.optionItems}
        className="styled_checkbox_for_multiselect"
        onChange={handleStateChange}
        placeholderButtonLabel="Select Fields"
        getDropdownButtonLabel={({placeholderButtonLabel, value}) =>
          renderSelectedLabel(placeholderButtonLabel, value)
        }
      />
      {searchWarning && <div className="text-danger">Load limit reached. Please use search.</div>}
    </>
  )
}

export default CustomMultiSelectFieldForAssign
